import { api } from './baseApi';
export var promoActionsApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getPromoActions: builder.query({
                query: function (_a) {
                    var _b = _a === void 0 ? {} : _a, _c = _b.page, page = _c === void 0 ? 1 : _c, _d = _b.limit, limit = _d === void 0 ? 10 : _d;
                    return ({
                        url: "/promoActions",
                        method: 'GET',
                        params: { page: page, limit: limit },
                    });
                },
                providesTags: ['PromoActions'],
            }),
            getPromoActionById: builder.query({
                query: function (id) {
                    return ({
                        url: "/promoActions/".concat(id),
                        method: 'GET',
                    });
                },
                providesTags: function (result, error, id) { return [{ type: 'PromoActions', id: id }]; },
            }),
            getPromoActionsByCity: builder.query({
                query: function (_a) {
                    var cityId = _a.cityId, _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.limit, limit = _c === void 0 ? 10 : _c;
                    return ({
                        url: "/promoActions/city/".concat(cityId),
                        method: 'GET',
                        params: { page: page, limit: limit },
                    });
                },
                providesTags: ['PromoActions'],
            }),
            createPromoAction: builder.mutation({
                query: function (formData) {
                    return ({
                        url: "/promoActions",
                        method: 'POST',
                        body: formData,
                    });
                },
                invalidatesTags: ['PromoActions'],
            }),
            updatePromoAction: builder.mutation({
                query: function (_a) {
                    var id = _a.id, data = _a.data;
                    return ({
                        url: "/promoActions/".concat(id),
                        method: 'PUT',
                        body: data,
                    });
                },
                invalidatesTags: function (result, error, _a) {
                    var id = _a.id;
                    return [{ type: 'PromoActions', id: id }];
                },
            }),
            deletePromoAction: builder.mutation({
                query: function (id) {
                    return ({
                        url: "/promoActions/".concat(id),
                        method: 'DELETE',
                    });
                },
                invalidatesTags: ['PromoActions'],
            }),
        });
    },
});
export var useGetPromoActionsQuery = promoActionsApi.useGetPromoActionsQuery, useGetPromoActionByIdQuery = promoActionsApi.useGetPromoActionByIdQuery, useGetPromoActionsByCityQuery = promoActionsApi.useGetPromoActionsByCityQuery, useCreatePromoActionMutation = promoActionsApi.useCreatePromoActionMutation, useUpdatePromoActionMutation = promoActionsApi.useUpdatePromoActionMutation, useDeletePromoActionMutation = promoActionsApi.useDeletePromoActionMutation;
